module.exports = __webpack_public_path__ + "img/ic_32_workout_medium.79304d0e.svg";